import styled from 'styled-components';
import { colorBackground } from 'theme/theme-helper-selectors';

export const FooterRoot = styled.footer`
    display: flex;
    flex-direction: column;
    background: ${colorBackground};
`;
